import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import ConferenceAgendaLayer from "./ConferenceAgendaLayer";


const ConferenceAgendaPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Components / Company Categories" />

        <ConferenceAgendaLayer />

      </MasterLayout>
    </>
  );
};

export default ConferenceAgendaPage;
